module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABRElEQVQ4jZXSMUjVURgF8N/LZ9liOmgZ5CMnEUUcxKEpXJyaHIJGBx11MWkQ3AQVN1EE51xdHP6DWBDpUEEYQQqCvun5EAddMp7DvQ/+PP7a80yX79zv3PPd7+SSJNnFK7zEiXviAd7FxpX7NkMep3iPTbShEZX/9OXwD6VckiTV4gWucB2d3YVKFCjnU8VP6MYIHtfh/g1m0wIr+IijOprhLX6nrW6jKRL1YBQH+ZriFiajkycYREFYcSc68CJyzzBRK7CAvXjuxQb+4hxF/EGCY3zDYa3AvrCFcazFV+9ErQAsYRVjuMRDIRsNqTs5YZVTWQIz+IIWtAuzplFEGc04yxKA70LE52/hP2AdpazEDeMnBnAg/HwVXdFBH37hdZbAEB5hGj14muIKeC6suhVDWSMsoh+fMYcfKW4n8l+FrCzfAMXLQmYx7J5GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/11.png
// module id = kn+3
// module chunks = 0